import { render, staticRenderFns } from "./HomeParallax.vue?vue&type=template&id=b7e6d52c&"
import script from "./HomeParallax.vue?vue&type=script&lang=js&"
export * from "./HomeParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports